'use client';

import { useAppDispatch, useAppSelector } from '@/app/lib/store/hooks';
import { getMessageByRoute } from '@/app/lib/schemas/mappers/misc-mappers';
import { useMemo } from 'react';
import SessionExpiredDialog from './session-expired-dialog';
import { useRouter } from 'next/navigation';
import { closeDialog } from '@/app/lib/store/auth-dialog-slice';

export default function SessionExpiredDialogContainer() {
  const open = useAppSelector(state => state.authDialog.isOpen);

  const route = useAppSelector(state => state.protectedRoute.name);
  const dispatch = useAppDispatch();

  const message = useMemo(() => getMessageByRoute(route), [route]);

  const router = useRouter();

  const handleClose = () => {
    router.refresh();
    dispatch(closeDialog());
  };

  return (
    <SessionExpiredDialog
      open={open}
      onClose={handleClose}
      message={message}
    />
  );
}
